<template>
<object-fit-wrapper class="image-slide" :aspectRatio="aspectRatio">
  <template v-slot:default="{contentStyle}">
    <img v-show="progress < 0.5" v-if="attributes.deckimage && attributes.beforesrc" :src="getSource(attributes.beforesrc)" alt="slide image">
    <img ref="slideContent" :src="getSource(attributes.src)" alt="slide image">
  </template>
</object-fit-wrapper>
</template>

<script>
import ObjectFitWrapper from './ObjectFitWrapper.vue'

export default {
  props: ['attributes', 'progress'],
  components: {ObjectFitWrapper},
  data () {
    return {
      aspectRatio: 1
    }
  },
  computed: {
    isTabletWidth () {
      return this.$window.innerWidth < 768
    },
    // aspectRatio () {
    //   console.log(this.$refs.slideContent)
    //   // const targetSlideContent = (typeof this.$refs.slideContent) this.$refs.slideContent[this.progress < 0.5 ? 0 : 1]
    //   // const {naturalWidth, naturalHeight} = targetSlideContent
    //   // return naturalHeight / naturalWidth
    //   return 1
    // }
  },
  mounted () {
    this.$emit('slideLoaded')
    this.$refs.slideContent.onload = () => {
      const {naturalWidth, naturalHeight} = this.$refs.slideContent
      this.aspectRatio = naturalHeight / naturalWidth
    }
  },
  methods: {
    getSource (value) {
      const {isTabletWidth} = this
      let [path, ext = 'jpg'] = value.split('.')
      path += (!isTabletWidth ? '-desktop.' : '.') + ext
      return require(`images/${path}`)
    }
  }
}
</script>

<style lang="scss">
.image-slide {
  img:first-of-type {
    z-index: 1;
  }

  // img {
  //   @supports(object-fit: cover) {
  //     object-fit: cover;
  //   }
  // }
}
</style>
